export default "__VITE_ASSET__COVa75iQ__"